// removed by extract-text-webpack-plugin
module.exports = {"anchor":"anchor___B4Haw","methodology-section":"methodology-section___2S30E","section-title":"section-title___lfN7N h1___3_4RF","answer-title":"answer-title___1Cmi1 h2___hzLuT","answer-info":"answer-info___1hJ9_"};


//////////////////
// WEBPACK FOOTER
// ./src/components/FossilFuelCompaniesContent/FossilFuelCompaniesContent.css
// module id = 911
// module chunks = 0